import React from 'react';
import TableYearsNavArrowsRight from './TableYearsNavArrowsRight';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';

const RankYearsNavArrowsLeftContainer = () => {
  const { state: { columnState, data: { periods = [] } }, increaseRankTablePosition } = useScorecardContext();
  const { rankTableIndex, rankTableColumnCount } = columnState;
  const isDisabled = (rankTableIndex + rankTableColumnCount) >= periods.length;

  return (
    <TableYearsNavArrowsRight
      isDisabled={ isDisabled }
      increaseTablePosition={ increaseRankTablePosition }
    />
  );
};

export default RankYearsNavArrowsLeftContainer;
